module.exports = __webpack_public_path__ + "img/home-emoji.c1e4a730.png";